<template>
  <el-dialog title="Visualizar etiqueta" center :visible.sync="dialog" :before-close="close">
    <el-form size="mini">
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="8" :lg="8" :xl="8">
          <el-form-item label="Objeto">
            <el-input v-model="record.tag" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item :label="$t('nome')" prop="name">
            <el-input disabled v-model="record.name" maxlength="60"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item label="CEP" prop="zipcode">
            <el-input maxlength="9" disabled v-model="record.zipcode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="12" :xl="12">
          <el-form-item :label="$t('endereco')" prop="address">
            <el-input disabled v-model="record.information.delivery.address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('numero')" prop="number">
            <el-input disabled type="number" maxlength="6" v-model="record.information.delivery.number"
              v-mask="'######'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="9" :xl="9">
          <el-form-item :label="$t('bairro')" prop="neighborhood">
            <el-input disabled v-model="record.information.national.neighborhood"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('complemento')" prop="complement">
            <el-input disabled v-model="record.information.delivery.complement"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="9" :xl="9">
          <el-form-item :label="$t('cidade')" prop="city">
            <el-input disabled v-model="record.information.national.city"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
          <el-form-item :label="$t('estado')" prop="state">
            <el-input disabled v-model="record.information.national.state"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="12" :sm="10" :md="8" :lg="8" :xl="8">
          <el-form-item :label="$t('servico')" prop="service">
            <el-input v-model="record.service" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('altura')" prop="height">
            <el-input disabled v-model="record.information.dimension.height"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('comprimento')" prop="width">
            <el-input disabled v-model="record.information.dimension.width"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('largura')" prop="length">
            <el-input disabled v-model="record.information.dimension.length"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('peso')" prop="weight">
            <el-input disabled v-model="record.weight"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item :label="$t('nota')" prop="invoice">
            <el-input disabled type="number" v-model="record.information.national.invoice"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="10" :md="6" :lg="6" :xl="6">
          <el-form-item label="Valor" prop="value">
            <el-input disabled v-model="record.value"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="10" :md="10" :lg="24" :xl="24">
          <el-form-item :label="$t('observacao')" prop="observation">
            <el-input type="textarea" disabled v-model="record.information.national.description"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialog = false">OK</el-button>
    </span>
  </el-dialog>
</template>
<script>

export default {
  name: "ExternalPostTagDetail",
  props: ["userType"],
  data() {
    return {
      dialog: false,
      record: {
        tag: '',
        name: '',
        zipcode: '',
        information: {
          delivery: {
            address: '',
            number: '',
            complement: '',
          },
          national: {
            neighborhood: '',
            city: '',
            state: '',
            invoice: '',
            description: '',
          },
          dimension: {
            height: 0,
            width: 0,
            length: 0,
          }
        }
      }
    };
  },
  methods: {
    open(record) {
      this.record = record;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
